// Shared NON-severity indicator colors (target-state design 2026-07-27, review D3).
// Severity has its own canonical module (utils/severity.js). These are the
// other colored indicators that had grown ad-hoc, duplicated per-component
// tables (ActionCandidateCard + RollupReport + PeerEvidence each had their own).
// One function per concept; components never invent their own maps.

/**
 * Action priority → Scoop color token.
 * LOW is deliberately neutral ('default'): green ('success') means
 * "good/healthy" everywhere else in the product — a low-priority action is
 * not a success state.
 */
export const priorityColor = (priority) => {
    switch (String(priority || '').trim().toUpperCase()) {
        case 'HIGH':
            return 'error'
        case 'MEDIUM':
            return 'warning'
        default:
            return 'default'
    }
}

/**
 * |z|-score band for peer-evidence outliers → Scoop color token.
 * z ≥ 2 is a statistical outlier (error), z ≥ 1 worth a look (warning).
 */
export const zBandColor = (zScore) => {
    const z = Math.abs(Number(zScore) || 0)
    if (z >= 2) return 'error'
    if (z >= 1) return 'warning'
    return 'default'
}
